// generated by srcset-codegen
import src from "./tag-10.svg";

const width = 10;
const height = 10;
export default { src, width, height };
